// 移动端公共页脚
<template>
  <div class="foot">
    <div class="nameimg"></div>
    <!-- <p class="toptxt">业务咨询：400-001-6911</p> -->
    <p class="toptxt">客服电话：0371-65353150</p>
    <p class="toptxt">地址：郑州市二七区大学路与淮河路口升龙天玺1幢17层</p>

    <h2>友情链接</h2>
    <a href="http://www.mohurd.gov.cn/">中华人民共和国住房和城乡建设部</a>
    <a href="https://hnjs.henan.gov.cn/">河南省住房和城乡建设厅</a>
    <a href="http://www.zgjzy.org.cn/">中国建筑业协会</a>
    <a href="http://www.yhtypt.com/">源恒通软件</a>
    <a href="http://ywtxxkj.cn">源伍通科技</a>
    <!-- <a href="http://www.lubansoft.com/">鲁班软件</a> -->

    <!-- <div class="oneErweima">
      <div class="yiweiimg"></div>详情咨询
    </div> -->
    <div class="twoErweima">
      <div class="erweiimg"></div>官方公众号
    </div>
    <div class="bottomTxt">技术支持：源伍通科技</div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="less">
.foot {
  width: 100%;
  height: 22rem;
  background-color: #f1f1f1;
  position: relative;
  .nameimg {
    width: 84%;
    height: 2.3rem;
    background: url("../../assets/img/icon/headernn.png") 0 0 no-repeat;
    background-size: 100%;
    // margin-top: 0.5rem;
  }
  .toptxt {
    line-height: 0.6rem;
  }
  a,
  p {
    width: 100%;
    opacity: 1;
    font-size: 0.6rem;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
    padding-left: 0.56rem;
    line-height: 0.5rem;
    box-sizing: border-box;
  }
  a{
      height: 1.2rem;
      line-height: 1.2rem;
      display: block;
  }
  h2 {
    opacity: 1;
    font-size: 0.8rem;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 500;
    text-align: left;
    color: #4279db;
    margin-left: 0.56rem;
    margin-top: 1rem;
  }
  .oneErweima {
    width: 5rem;
    height: 5rem;
    text-align: center;
    position: absolute;
    font-size: 0.6rem;
    bottom: 3rem;
    right: 7rem;
    .yiweiimg {
      width: 4rem;
      height: 4rem;
      margin: 0 auto;
      margin-bottom: 0.3rem;
      background: url("../../assets/img/首页/wxErWeiMa.jpg") 0 0 no-repeat;
      background-size: 100%;
    }
  }
  .twoErweima {
    width: 5rem;
    height: 5rem;
    text-align: center;
    font-size: 0.6rem;
    position: absolute;
    bottom: 3rem;
    right: 1.5rem;
    .erweiimg {
      width: 4rem;
      height: 4rem;
      margin: 0 auto;
      margin-bottom: 0.3rem;
      background: url("../../assets/img/首页/gcErWeiMa.jpg") 0 0 no-repeat;
      background-size: 100%;
    }
  }
  .bottomTxt {
    width: 100%;
    height: 1.5rem;
    line-height: 1.5rem;
    border-top: 0.1rem solid #4279db;
    position: absolute;
    text-align: center;
    bottom: 0;
    opacity: 1;
    font-size: 0.6rem;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 500;
    color: #333333;
    padding-top: 0.2rem;
  }
}
</style>
